// extracted by mini-css-extract-plugin
export var avatarContainer = "_9m-0";
export var avatarTypingWave = "_9m-i";
export var gray = "_9m-f";
export var green = "_9m-c";
export var icon = "_9m-9";
export var image = "_9m-1";
export var lg = "_9m-6";
export var md = "_9m-5";
export var presenceDot = "_9m-b";
export var red = "_9m-d";
export var sm = "_9m-4";
export var status = "_9m-a";
export var typingDot = "_9m-h";
export var typingPill = "_9m-g";
export var xl = "_9m-7";
export var xs = "_9m-3";
export var xxl = "_9m-8";
export var xxs = "_9m-2";
export var yellow = "_9m-e";